module.exports = __webpack_public_path__ + "static/media/cvc_card.0bcd201e.svg";